import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import styles from './styles.css';

@autobind
export default class Input extends Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        search: PropTypes.bool,
        className: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
    };

    handleChange(event) {
        this.props.onChange(event.target.value);
    }

    render() {
        return (
            <input
                className={classNames(styles.root, this.props.className, {
                    [styles.disabled]: this.props.disabled,
                    [styles.search]: this.props.search,
                })}
                type={this.props.type}
                value={this.props.value}
                min={this.props.min}
                max={this.props.max}
                placeholder={this.props.placeholder}
                disabled={this.props.disabled}
                onChange={this.handleChange}
                onBlur={this.props.onBlur}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/input/index.js